module.exports = __webpack_public_path__ + "img/Roxe_QR.9ca61463.png";